import { CircularProgress, Input } from '@mui/joy';
import { useSpinDelay } from 'spin-delay';

import SearchIcon from '@/assets/icons/search.svg?react';

type TableSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  isFetching: boolean;
};

export function TableSearchInput({ value, onChange, placeholder, isFetching }: TableSearchInputProps) {
  const showCircularProgress = useSpinDelay(isFetching);

  return (
    <Input
      startDecorator={<SearchIcon style={{ color: 'var(--joy-palette-primary-500)' }} />}
      endDecorator={showCircularProgress && <CircularProgress size="sm" />}
      placeholder={placeholder}
      aria-label={placeholder}
      value={value}
      size="md"
      variant="outlined"
      onChange={(event) => onChange(event.currentTarget.value)}
      sx={{ marginBottom: 3, flexGrow: 1 }}
    />
  );
}
